var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100vh"}},[_c('el-aside',{staticStyle:{"width":"185px"}},[_c('sidebar')],1),_c('el-container',[_c('el-header',[_c('navbar')],1),_c('el-main',[_c('router-view')],1)],1),(_vm.isIdle)?_c('modal-idle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }